import React, { useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { useGetReferralInfoQuery } from '../../redux/apis/endpoints/creditApi';
import './InviteFriendsButton.css';

/**
 * InviteFriendsButton - Share referral link for credits
 * Uses native share API on mobile, clipboard copy on desktop
 */
const InviteFriendsButton = ({ className = '', ...props }) => {
    const { data: referralInfo, isLoading } = useGetReferralInfoQuery();
    const [copied, setCopied] = useState(false);

    const handleShare = async () => {
        if (!referralInfo?.referralLink) return;

        const shareText = `Join me on SUSU Closet for virtual try-on! Sign up here and we both get free credits: ${referralInfo.referralLink}`;

        // Try native share API first (mobile)
        if (navigator.share) {
            try {
                await navigator.share({
                    title: 'SUSU Closet Invite',
                    text: shareText,
                    url: referralInfo.referralLink
                });
                return;
            } catch (err) {
                // User cancelled or share failed - fall through to clipboard
                if (err.name !== 'AbortError') {
                    console.log('Native share failed, using clipboard:', err);
                }
            }
        }

        // Desktop fallback - copy to clipboard
        copyToClipboard(referralInfo.referralLink);
    };

    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            setTimeout(() => setCopied(false), 2500);
        } catch (err) {
            console.error('Failed to copy to clipboard:', err);
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            setCopied(true);
            setTimeout(() => setCopied(false), 2500);
        }
    };

    if (isLoading) {
        if (props.variant === 'text') return null;
        return (
            <Button color="teal" loading className={`invite-friends-btn ${className}`} {...props}>
                Loading...
            </Button>
        );
    }

    if (props.variant === 'text') {
        if (!referralInfo?.referralLink) return null;
        return (
            <div
                className={`invite-friends-text-link ${className}`}
                onClick={handleShare}
                style={{ textAlign: 'center', fontSize: 13, color: '#00b5ad', cursor: 'pointer', ...props.style }}
            >
                {copied ? 'Link Copied!' : `Invite a friend — you both get +${referralInfo.creditsPerReferral || 3} credits`}
            </div>
        );
    }

    return (
        <Button
            color={copied ? 'blue' : 'teal'}
            className={`invite-friends-btn ${className}`}
            onClick={handleShare}
            disabled={!referralInfo?.referralLink}
            icon
            style={{ paddingLeft: '20px', paddingRight: '10px' }}
            {...props}
        >
            <Icon name={copied ? 'check' : 'share alternate'} />
            <span style={{ marginLeft: '8px' }}>
                {copied ? 'Link Copied!' : 'Invite Friends for Credits'}
            </span>
            {referralInfo?.creditsPerReferral && !copied && (
                <span style={{ paddingLeft: '8px', opacity: 0.9 }}>
                    +{referralInfo.creditsPerReferral}
                </span>
            )}
        </Button>
    );
};

export default InviteFriendsButton;
